// ProjectUsageTable.tsx
import React, { useMemo, useState, useCallback } from "react";

// Mantine
import { Title, Stack, Group, Modal, Text, Divider, Loader, Center } from "@mantine/core";

import { useAppSelector } from "../../../hooks";

import { useGetUsageAggregateProjectQuery, useGetUsageAggregateProjectStartsQuery } from "../../../../openapi";

const ProjectUsageModal: React.FC<{
  projectId: string | null;
  onClose: () => void;
}> = React.memo(({ projectId, onClose }) => {
  const fromDate = useAppSelector((s) => s.statsReducer.fromDate);
  const toDate = useAppSelector((s) => s.statsReducer.toDate);

  const { data, isFetching, isUninitialized, error } = useGetUsageAggregateProjectQuery(
    {
      fromDate: fromDate,
      toDate: toDate,
      projectId: projectId ?? "",
    },
    { skip: !projectId },
  );

  const opened = Boolean(projectId);

  return (
    <Modal opened={opened} onClose={onClose} title="Prosjektstatistikk" size="lg" radius="lg" withinPortal>
      {!projectId || isFetching || isUninitialized ? (
        <Center py="md">
          <Loader />
        </Center>
      ) : error ? (
        <Text c="red">Failed to load project usage.</Text>
      ) : (
        <Stack gap="sm">
          <Title order={4}>Brukere (topp 10)</Title>
          {data?.users?.map((u) => (
            <Group key={u.name} justify="space-between">
              <Text>{u.name}</Text>
              <Text fw={600}>{u.count}</Text>
            </Group>
          ))}

          <Divider my="sm" />

          <Title order={4}>Appstarter</Title>
          {data?.appStarts?.map((a) => (
            <Group key={a.name} justify="space-between">
              <Text>{a.name}</Text>
              <Text fw={600}>{a.count}</Text>
            </Group>
          ))}
        </Stack>
      )}
    </Modal>
  );
});

export default ProjectUsageModal;
